import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useMediaQuery } from '@material-ui/core'
import FooterAfi from './FooterAfi'
import { withThemeProps } from '@findep/microfronts-core'

function FooterFindep({ broker, companyName, data, lang, estado, txtAccesible,txtButton,txtContent}) {
  const [actfoot, setActfoot] = useState(null)
  const [estadoFinal, setEstadoFinal] = useState(estado)

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const term = urlParams.get('term') || 'notYet'
    const nuevoEstado = term === "idmedio_1413" ? 'TX' : estado
    setEstadoFinal(nuevoEstado)
  }, [estado])

  let afi_match = ''
        switch (estadoFinal) {            
            case 'AZ':
              afi_match = 'Arizona'
              break;
            case 'TX':
              afi_match = 'Texas'
              break;
            case 'CA':default: 
              afi_match =  'California'
            break;
        }

  let matches = useMediaQuery('(min-width:768px)');
  let footer = []

  if ((broker !== undefined && broker !== null)) {
    footer = data.allComponentsJson.edges[0].node.footer.find(item => (item.company === companyName && item.broker === broker && item.lang === lang && item.state === afi_match))

    if (footer === undefined) {
      footer = data.allComponentsJson.edges[0].node.footer.find(item => item.company === companyName && item.lang === lang && item.state === afi_match)

    }
  } else {
    footer = data.allComponentsJson.edges[0].node.footer.find(item => item.company === companyName && item.lang === lang && item.state === afi_match)
  }

 
  let leyendas = footer.leyendas
  let linkone = footer.linkone
  let linktree = footer.linktree
  let linktwo = footer.linktwo
  let terminosyavisosafileft = footer.terminosyavisosafileft
  let terminosyavisosafiright = footer.terminosyavisosafiright

  useEffect(() => {
    const foot = sessionStorage.getItem('foot')
    setActfoot(foot)
  }, [])

  return (
    <>
      <div
        style={{
          height: !matches ? '20px' : actfoot  ? '0px' :'60px',
          background: '#fafaf8',
        }}
      />
  
        <FooterAfi
          afi
          terminosyavisosafiright={terminosyavisosafiright}
          terminosyavisosafileft={terminosyavisosafileft}
          fontsectionone={{ family: 'Roboto-Condensed', size: '14px', redesSize: '17px' }}
          linkone={linkone}
          linktwo={linktwo}
          linktree={linktree}
          leyendas={leyendas}
          colorfooter="#eeedf0"              
          txtAccesible={txtAccesible}
          txtButton={txtButton}
          txtContent={txtContent}
        />      
    </>
  )
}

FooterFindep.propTypes = {
  companyName: PropTypes.oneOf(['AEF', 'AFI', 'FISA']),
  data: PropTypes.object.isRequired,
  lang: PropTypes.string,
  txtAccesible: PropTypes.string,
  txtContent: PropTypes.string,
  txtButton: PropTypes.string,
}

FooterFindep.defaultProps = {
  lang: 'es',
  txtAccesible:'Accesibilidad del Sitio',
  txtContent:'Apoyo Financiero, Inc. está comprometido con asegurar el acceso digital para personas con discapacidad. Le agradeceremos compartir cualquier problema respecto a la accesibilidad del sitio web en el siguiente correo electrónico: accessibility@apoyofin.com',
  txtButton: 'cerrar'
}
export default withThemeProps(FooterFindep, 'VDNPFooterFindep')
